import { render, staticRenderFns } from "./table-budget-costs.vue?vue&type=template&id=45667b4e&scoped=true&"
import script from "./table-budget-costs.vue?vue&type=script&lang=ts&"
export * from "./table-budget-costs.vue?vue&type=script&lang=ts&"
import style0 from "./table-budget-costs.vue?vue&type=style&index=0&id=45667b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45667b4e",
  null
  
)

export default component.exports